import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { AppRestrictedComponent } from './app-restricted.component';

@NgModule({
    declarations: [
        AppRestrictedComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        ReactiveFormsModule,
    ]
})
export class AppRestrictedModule { }